import { EVisitType } from '@giffgaff/broadband-common'

import { Button, Modal } from '@fe-toolkit/web-components/ssr'

import LearnMoreAboutOutsideInstallModalContent from '../LearnMoreAboutInstallsModalContent/LearnMoreAboutOutsideInstallModalContent'
import LearnMoreAboutHomeInstallModalContent from '../LearnMoreAboutInstallsModalContent/LearnMoreAboutHomeInstallModalContent'

type Props = {
  visitType: EVisitType | null
  closeModal: () => void
}

const LearnMoreAboutInstallsModal = ({ visitType, closeModal }: Props) => {
  return (
    <Modal closeModal={closeModal} display={visitType !== null} modalBackgroundColour="gallery" setDisplay={() => {}}>
      {visitType === EVisitType.IN_HOME ? (
        <LearnMoreAboutHomeInstallModalContent />
      ) : (
        <LearnMoreAboutOutsideInstallModalContent />
      )}

      <Button
        isFullWidth
        sx={{
          marginTop: '24px',
          padding: '16px',
          backgroundColor: 'white',
        }}
        variant="link"
        onClick={closeModal}
      >
        Close
      </Button>
    </Modal>
  )
}

export default LearnMoreAboutInstallsModal
